


import useBacktestStore from '../Store/backtestStore';

let ws = null;

export function connectBacktestWs() {
  // const WS_URL = 'ws://localhost:4001/ws';
  const WS_URL = 'wss://one-dte-iron-condor-backend-22b99d211e32.herokuapp.com/ws';

  if (ws) {
    console.warn('[ARGOS WS] Already connected');
    return () => {};
  }

  const socket = new WebSocket(WS_URL);
  ws = socket;

  socket.onopen = () => {
    console.log('[ARGOS WS] Connected');

    socket.send(
      JSON.stringify({
        type: 'get_argos_equity',
      })
    );
  };

  socket.onmessage = (event) => {
    let msg;

    try {
      msg = JSON.parse(event.data);
    } catch (error) {
      console.error('[ARGOS WS] Failed to parse message:', error);
      return;
    }

    if (msg.type === 'argos_equity') {
      const equitySeries = Array.isArray(msg.equitySeries)
        ? msg.equitySeries
        : [];

      const latestClosedEquity =
        msg.latestClosedEquity !== undefined && msg.latestClosedEquity !== null
          ? Number(msg.latestClosedEquity)
          : null;

      console.log('[ARGOS WS] Equity rows received:', equitySeries.length);
      console.log('[ARGOS WS] Latest closed equity:', latestClosedEquity);

      const store = useBacktestStore.getState();

      store.setArgosEquitySeries(equitySeries);
      store.setArgosLatestClosedEquity(latestClosedEquity);

      return;
    }

    if (msg.type === 'error') {
      console.error('[ARGOS WS] Server error:', msg.message);
      return;
    }

    console.warn('[ARGOS WS] Unhandled message type:', msg.type);
  };

  socket.onerror = (err) => {
    console.error('[ARGOS WS] Error:', err);
  };

  socket.onclose = () => {
    console.log('[ARGOS WS] Disconnected');
    ws = null;
  };

  return () => {
    try {
      socket.close();
    } catch (_) {}

    if (ws === socket) {
      ws = null;
    }
  };
}
